import { Box, Button, Text } from '@chakra-ui/react';
import * as React from 'react';

import aiAskSourceStyles from '../../AIAskSources.module.css';
import type { SearchRedirectAssistantMessage } from '../../types';
import { FormattedText } from '../shared/FormattedText';

export const SearchRedirectAnswer: React.FC<{
  message: SearchRedirectAssistantMessage;
  onSwitchToSearch: () => void;
  isLoading: boolean;
}> = ({ message, onSwitchToSearch, isLoading }) => {
  const answerText = String(message.answer ?? '').trim();
  const hasQuery = Boolean(message.originalQuery?.trim());

  return (
    <Box>
      {answerText ? (
        <Text className={aiAskSourceStyles.askText} mb={3} as="div">
          <FormattedText text={answerText} />
        </Text>
      ) : null}

      <Button
        size="sm"
        colorScheme="blue"
        variant="solid"
        onClick={onSwitchToSearch}
        isLoading={isLoading}
        isDisabled={!hasQuery}
        title={
          hasQuery
            ? 'Open Search with this query'
            : 'Search query unavailable'
        }
      >
        View Search Results
      </Button>

      {message.viewResultsError ? (
        <Text fontSize="sm" color="red.500" mt={2}>
          {message.viewResultsError}
        </Text>
      ) : null}
    </Box>
  );
};
